module.exports = {
	"server": ""
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./client/app/config.json
// module id = 208
// module chunks = 0